// $FlowFixMe
/* eslint-disable flowtype/no-types-missing-file-annotation */

type oauthArgs = {
  code: string,
  state: string,
  redirect_uri: string,
}
export const getOauthUrlRedirect = ({ code, state, redirect_uri }: oauthArgs) => `${redirect_uri}?code=${code}&state=${state}`; // eslint-disable-line camelcase

type zendeskArgs = {
  jwt: string,
  return_to: string,
  redirect_uri: string,
}
export const getZendeskUrlRedirect = ({ jwt, return_to, redirect_uri }: zendeskArgs) => `${redirect_uri}?jwt=${jwt}&return_to=${return_to}`; // eslint-disable-line camelcase

type cannyArgs = {
  company_id: string,
  sso_token: string,
  redirect: string,
  redirect_uri: string,
}
/* eslint-disable camelcase */
export const getCannyUrlRedirect = ({
  company_id, sso_token, redirect, redirect_uri,
}: cannyArgs) => `${redirect_uri}?companyID=${company_id}&redirect=${redirect}&ssoToken=${sso_token}`;
/* eslint-enable camelcase */

type espnActivateArgs = {
  token: string,
  providerId: string,
  dss_branch: string,
  dss_backend_services: string,
  redirect_uri: string,
}
/* eslint-disable camelcase */
export const getESPNActivateUrlRedirect = ({
  token, providerId, dss_branch, redirect_uri, dss_backend_services,
}: espnActivateArgs) => {
  const url = new URL(redirect_uri);

  if (token) {
    url.searchParams.set('token', token);
  }

  if (providerId) {
    url.searchParams.set('providerId', providerId);
  }

  if (dss_branch) {
    url.searchParams.set('dss_branch', dss_branch);
  }

  if (dss_backend_services) {
    url.searchParams.set('dss_backend_services', dss_backend_services);
  }

  return url.toString();
};
/* eslint-enable camelcase */
